module.exports = __webpack_public_path__ + "7c94d4761059536e097f784318f2b0f9.svg";